import numeral from "numeral";

export function shortenNumber(num: number): string {
	return numeral(num).format(
		numeral(num).value() <= 1000000 ? "$0a" : "$ 0.00a"
	);
}

export function shortenNumberUnder10k(num: number): string {
	return numeral(num).format("$0,0");
}

const specialChars = {
	à: "a",
	ä: "a",
	á: "a",
	â: "a",
	æ: "a",
	å: "a",
	ë: "e",
	è: "e",
	é: "e",
	ê: "e",
	î: "i",
	ï: "i",
	ì: "i",
	í: "i",
	ò: "o",
	ó: "o",
	ö: "o",
	ô: "o",
	ø: "o",
	ù: "o",
	ú: "u",
	ü: "u",
	û: "u",
	ñ: "n",
	ç: "c",
	ß: "s",
	ÿ: "y",
	œ: "o",
	ŕ: "r",
	ś: "s",
	ń: "n",
	ṕ: "p",
	ẃ: "w",
	ǵ: "g",
	ǹ: "n",
	ḿ: "m",
	ǘ: "u",
	ẍ: "x",
	ź: "z",
	ḧ: "h",
	"·": "-",
	"/": "-",
	_: "-",
	",": "-",
	":": "-",
	";": "-"
};

/* eslint-disable */
export function slugify(text) {
	return text
		.toString()
		.toLowerCase()
		.replace(/\s+/g, "-") // Replace spaces with -
		.replace(/./g, (target) => specialChars[target] || target) // Replace special characters using the hash map
		.replace(/&/g, "-and-") // Replace & with 'and'
		.replace(/[^\w\-]+/g, "") // Remove all non-word chars
		.replace(/\-\-+/g, "-") // Replace multiple - with single
		.replace(/^-+/, "") // Trim - from start of text
		.replace(/-+$/, ""); // Trim - from end of text
}
/* eslint-enable */

export function shortenGender(word: string): string {
	const words = word.split(" or ");
	return words.length > 1
		? words.map((w) => w.split("")[0]).join("/")
		: words.map((w) => w.split("", 1)).toString();
}

export function formatFrequency(word: string): string {
	return word.length
		? "/" + word.toLowerCase().replace("ly", "")
		: "/not specified";
}

export function pageName(name: string): string {
	return name
		.split("-")
		.map((segment) => {
			return segment.charAt(0).toUpperCase() + segment.slice(1);
		})
		.join("");
}

export const capitalize = (s) => {
	if (typeof s !== "string") return "";
	return s.charAt(0).toUpperCase() + s.slice(1);
};
